import Enumerator from '../global/Enumerator';
import { replaceEnumUnsafe } from '../../util/transform';

export const auStatesTypes = ['NONE', 'ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'];

export class AuStateType extends Enumerator {
  static default() {
    return this.of('NONE');
  }

  static of(type?: string) {
    return this.enumValueOf(replaceEnumUnsafe(type)) || this.default();
  }
}

AuStateType.initEnum({
  NONE: {
    get id() {
      return 0;
    },
    get title() {
      return 'Select';
    },
    get weight() {
      return 1;
    }
  },
  ACT: {
    get id() {
      return 'ACT';
    },
    get title() {
      return 'Australian Capital Territory';
    },
    get weight() {
      return 2;
    }
  },
  NSW: {
    get id() {
      return 'NSW';
    },
    get title() {
      return 'New South Wales';
    },
    get weight() {
      return 3;
    }
  },
  NT: {
    get id() {
      return 'NT';
    },
    get title() {
      return 'Northern Territory';
    },
    get weight() {
      return 4;
    }
  },
  QLD: {
    get id() {
      return 'QLD';
    },
    get title() {
      return 'Queensland';
    },
    get weight() {
      return 5;
    }
  },
  SA: {
    get id() {
      return 'SA';
    },
    get title() {
      return 'South Australia';
    },
    get weight() {
      return 6;
    }
  },
  TAS: {
    get id() {
      return 'TAS';
    },
    get title() {
      return 'Tasmania';
    },
    get weight() {
      return 7;
    }
  },
  VIC: {
    get id() {
      return 'VIC';
    },
    get title() {
      return 'Victoria';
    },
    get weight() {
      return 8;
    }
  },
  WA: {
    get id() {
      return 'WA';
    },
    get title() {
      return 'Western Australia';
    },
    get weight() {
      return 9;
    }
  }
});

export default {
  auStatesTypes,
  AuStateType
};
